import { FONT } from "@/styles";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { RoomInfos, RoomPictures } from "./components";
import { type RoomContentsProps } from "./roomContents.type";

export const RoomContents = ({ data, contentMode, targetRoomIdx }: RoomContentsProps) => {
    const [focusRoomIdx, setFocusRoomIdx] = useState<string>(targetRoomIdx);
    const scrollRef = useRef<HTMLDivElement>(null);
    const { rooms } = { ...data };
    /* eslint-disable consistent-return */
    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        const handleWheel = (e: WheelEvent) => {
            if (e.deltaY !== 0) {
                e.preventDefault();
                el.scrollTo({
                    left: el.scrollLeft + e.deltaY,
                });
            }
        };

        el.addEventListener("wheel", handleWheel, { passive: false });
        return () => el.removeEventListener("wheel", handleWheel);
    }, [data]);
    /* eslint-disable consistent-return */
    return (
        <Flex w="100%" overflow="hidden" flexDir="column" gap="16px">
            <Box ref={scrollRef} w="100%" overflowX="auto">
                <Flex w="max-content" gap="16px" pb="24px">
                    {rooms.map((room) => (
                        <Center
                            flexShrink="0"
                            key={room.room_idx}
                            h="40px"
                            p="0 16px"
                            border={`1px solid ${focusRoomIdx === room.room_idx ? "#3b6c8d" : "#333"}`}
                            bg={focusRoomIdx === room.room_idx ? "#3b6c8d" : "#fff"}
                            borderRadius="20px"
                            cursor="pointer"
                            color={focusRoomIdx === room.room_idx ? "#fff" : "#333"}
                            onClick={() => setFocusRoomIdx(room.room_idx)}
                        >
                            <Text {...FONT("pretendard", 16, 400, 1.4)}>{room.room_name}</Text>
                        </Center>
                    ))}
                </Flex>
            </Box>
            {contentMode === "pic" ? (
                <RoomPictures rooms={rooms} targetIdx={Number(focusRoomIdx)} />
            ) : (
                <RoomInfos rooms={rooms} targetRoomIdx={Number(focusRoomIdx)} />
            )}
        </Flex>
    );
};
